import configHelper from '@/config/ConfigHelper'
// import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: 'Stripe'
    },
    {
      id: 2,
      name: 'PayPal'
    },
    // {
    //   id: null,
    //   name: i18n.t('app.not_applicable')
    // }
  ]
}

export function TIPOS_RECOBRO (state) {
  return configHelper.getConfig(state, 'TIPOS_RECOBRO', GenerateConfig)
}
